<template lang="pug">
.cp-tip(v-if="show", :class="show ? 'showtip' : ''")
  span {{tip}}
</template>
<script>
export default {
  components: {},
  props: {
  },
  data () {
    return {
      show: false,
      tip: '',
    }
  },
  computed: {},
  methods: {
    showTip (tip) {
      this.show = true
      this.tip = tip
      setTimeout(() => {
        this.show = false
      }, 2000)
    }
  }
}
</script>
<style lang="stylus">
.cp-tip
  width 170px
  line-height 50px
  text-align center
  background #fff
  position fixed
  left 50%
  top 50px
  transform translate(-50%, 0)
  box-shadow 0 1px 6px rgba(0,0,0,.2)
  border-radius 10px
  animation showTip .5s
  span
    font-size 16px
    color black
  .showTip
    animation showTip .3s
@keyframes showTip {
  from {
    transform translate(-50%, -10px) scale(.4)
  }
  to {
    transform translate(-50%, 0px) scale(1)
  }
}
</style>
